
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../../../molecules/organization/FilterContainer.vue";
import ServiceFilter from "../filters/ServiceFilter.vue";
import ProductFilter from "../filters/ProductFilter.vue";

import { QuiltyInsightsFilterStore } from "../../../stores/quiltyInsights/QuiltyInsightsFilterStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import FormInput from "../../../../../landing/src/molecules/form/FormInput.vue";
import NoRecords from "../../../../../common/src/components/NoRecords.vue";
import OperatingRegimeFilter from "../filters/OperatingRegimeFilter.vue";
import ApplicationFilter from "../filters/ApplicationFilter.vue";
import FilterHeader from "../filters/FilterHeader.vue";

@Component({
    components: {
        FilterHeader,
        ProductFilter,
        ServiceFilter,
        ApplicationFilter,
        OperatingRegimeFilter,
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
    },
})
export default class QuiltyInsightsSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    quiltyInsightsFilterStore: QuiltyInsightsFilterStore =
        this.container.get(QuiltyInsightsFilterStore);
}
